import React, { lazy, useEffect } from 'react'
import _get from 'lodash/get'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect as connectRedux } from 'react-redux'
import { getBoundActions } from '../../actions/index'
import { get as getConfig } from '../../config/index'
import { getPageTitle } from '../../services/page/index'
import { connect as connectAlertBar } from '../AlertBar/connect'
import GoogleTagManager from '../GoogleTagManager/index'
import InboundTracking from '../InboundTracking/index'
import Interstitial from '../Interstitial/index'
import Resolver from '../Resolver/index'
import Toasty from '../Toasty/index'

const config = getConfig()
const popupFeatureToggle = _get(config, ['features', 'marketing', 'specialOfferPromoPopup'])

const LoadableMainLoader = lazy(
  () => import('../MainLoader/index'),
)

const LoadablePopupMarketingPromo = lazy(
  () => import('../PopupMarketingPromo/index'),
)

function renderPopup (location) {
  if (popupFeatureToggle) {
    return (
      <LoadablePopupMarketingPromo
        location={location}
        timer={30000}
      />
    )
  }
  return null
}

/**
 * The main section of the app
 * @type {React.ReactElement}
 * @param {Object} props The props
 */
function Main (props) {
  const {
    initAlertBarTypeLanguage,
    bootstrapComplete,
    renderApp,
    location,
    children,
    history,
    title,
  } = props

  useEffect(() => {
    if (bootstrapComplete) {
      initAlertBarTypeLanguage()
    }
  }, [bootstrapComplete])

  return (
    <div id="main-app">
      <div className="main">
        <GoogleTagManager location={location} pageTitle={title} />
        <InboundTracking location={location} />
        <main className="main__content">
          {renderApp ? children : null}
        </main>
        {bootstrapComplete ? (
          <React.Suspense>
            <LoadableMainLoader location={location} history={history} />
            {renderPopup(location)}
            <Interstitial />
            <Resolver history={history} />
            <Toasty />
          </React.Suspense>
        ) : null}
      </div>
    </div>
  )
}

Main.propTypes = {
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  client: PropTypes.object,
}

export default compose(
  connectAlertBar(),
  connectRedux(
    (state) => ({
      bootstrapComplete: state.app.get('bootstrapComplete'),
      location: state.resolver.get('location'),
      renderApp: state.app.get('renderApp'),
      title: getPageTitle(state.page),
    }),
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return { initAlertBarTypeLanguage: actions.alertBar.initAlertBarTypeLanguage }
    },
  ),
)(Main)
